
import React, { useState } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo_1024.png";

import "./layout.css";

export default function MainLayOut() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Cuộn đến section trên trang Home
  const handleNavClick = (sectionId) => {
    closeMobileMenu();

    if (location.pathname !== "/") {
      navigate(`/#${sectionId}`);
      return;
    }

    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleHomeClick = () => {
    closeMobileMenu();

    if (location.pathname !== "/") {
      navigate("/");
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="main-layout">
      {/* ==================== HEADER ==================== */}
      <header className="main-header">
        <div className="header-container">
          {/* Logo */}
          <Link
            to="/"
            className="brand-logo"
            onClick={handleHomeClick}
          >
            <div className="brand-logo-image-wrapper">
              <img
                src={logo}
                alt="Dò Vé Số AI Logo"
                className="brand-logo-image"
              />
            </div>

            <div className="brand-info">
              <span className="brand-name">
                Dò Vé Số <span>AI</span>
              </span>

              <span className="brand-tagline">
                Trợ Lý Dò KQXS Thông Minh
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("about");
              }}
            >
              <i className="fa-solid fa-house" />
              Giới Thiệu
            </a>

            <a
              href="#features"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("features");
              }}
            >
              <i className="fa-solid fa-star" />
              Tính Năng
            </a>

            <a
              href="#guide"
              className="guide-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("guide");
              }}
            >
              <i className="fa-solid fa-book-open" />
              Hướng Dẫn Sử Dụng
            </a>

            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("contact");
              }}
            >
              <i className="fa-solid fa-envelope" />
              Liên Hệ
            </a>
          </nav>

          {/* Download Button */}
          <div className="header-action">
            <a
              href="#download"
              className="download-button"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("download");
              }}
            >
              <i className="fa-solid fa-download" />
              Tải App Miễn Phí
            </a>
          </div>

          {/* Mobile Button */}
          <button
            type="button"
            className="mobile-menu-button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={
              mobileMenuOpen ? "Đóng menu" : "Mở menu"
            }
            aria-expanded={mobileMenuOpen}
          >
            <i
              className={
                mobileMenuOpen
                  ? "fa-solid fa-xmark"
                  : "fa-solid fa-bars"
              }
            />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("about");
              }}
            >
              <i className="fa-solid fa-house" />
              Giới Thiệu
            </a>

            <a
              href="#features"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("features");
              }}
            >
              <i className="fa-solid fa-star" />
              Tính Năng Nổi Bật
            </a>

            <a
              href="#guide"
              className="mobile-guide-link"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("guide");
              }}
            >
              <i className="fa-solid fa-book-open" />
              Hướng Dẫn Sử Dụng
            </a>

            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("contact");
              }}
            >
              <i className="fa-solid fa-envelope" />
              Liên Hệ
            </a>
            <a
              href="#download"
              className="mobile-download-button"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("download");
              }}
            >
              <i className="fa-solid fa-download" />
              Tải Ứng Dụng Ngay
            </a>
          </div>
        )}
      </header>

      {/* ==================== CONTENT ==================== */}
      <Outlet />

      {/* ==================== FOOTER ==================== */}
      <footer className="main-footer" id="contact">
        <div className="container">
          <div className="footer-grid">
            {/* Brand */}
            <div className="footer-brand">
              <div className="footer-brand-title">
                <div className="footer-logo">
                  <img src={logo} alt="Logo Footer" />
                </div>
                <span>
                  Dò Vé Số <strong>AI</strong>
                </span>
                
              </div>

              <p>
                Ứng dụng tra cứu và tự động kiểm tra kết quả xổ số kiến thiết 3 Miền bằng trí tuệ nhân tạo.
              </p>
            </div>

            {/* Contact */}
            <div className="footer-column">
              <h4>Liên Hệ</h4>

            <p className="contact-email">
              <i className="fa-solid fa-envelope" />
              <a href="mailto:ct7solutions@gmail.com" className="email-link">
                ct7solutions@gmail.com
              </a>
            </p>

              <h4>Kết Nối Với Chúng Tôi</h4>
              <div className="social-links">
                <a
                  href={process.env.REACT_APP_FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fa-brands fa-facebook" />
                </a>

                <a
                  href={process.env.REACT_APP_YOUTUBE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <i className="fa-brands fa-youtube" />
                </a>

                <a
                  href={process.env.REACT_APP_TIKTOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TikTok"
                >
                  <i className="fa-brands fa-tiktok" />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-policy">
              <Link to="/chinh-sach-bao-mat">Chính sách bảo mật</Link>
              <Link to="/dieu-khoan-dich-vu">Điều khoản dịch vụ</Link>
            </div>

            <p>© 2026 Dò Vé Số AI. Tất cả các quyền được bảo lưu.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}